import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';

import ArrowBack from '@mui/icons-material/ArrowBack';

import Button from '@ts-core/components/Button';
import StudentForm from 'modules/students/components/StudentForm';

const useStyles = makeStyles((theme) => ({
  searchButton: {
    marginLeft: theme.spacing(1),
  },
  resetButton: {
    marginLeft: -theme.spacing(2),
  },
}));

const AddStudentForm = (props) => {
  const { student, groups, loading, submitting, onSearchStudent, onAddStudent, onResetForm } = props;

  const classes = useStyles();
  const [query, setQuery] = useState('');

  const handleQueryChange = useCallback((event) => {
    setQuery(event.target.value);
  }, []);

  const handleSearchStudent = useCallback(() => {
    onSearchStudent(query);
  }, [query, onSearchStudent]);

  const handleReset = useCallback(() => {
    setQuery('');
    onResetForm();
  }, [onResetForm]);

  return (
    <Box display="flex" flexDirection="column" width="100%">
      {isEmpty(student) ? (
        <Box display="flex" flexDirection="row" alignItems="flex-end" mb={1}>
          <TextField
            fullWidth
            required
            label={<FormattedMessage id="addStudentForm.searchField" />}
            type="text"
            onChange={handleQueryChange}
            value={query}
          />
          <Button
            className={classes.searchButton}
            color="primary"
            variant="contained"
            loading={loading}
            disabled={isEmpty(query)}
            onClick={handleSearchStudent}
          >
            <FormattedMessage id="addStudentForm.button.search" />
          </Button>
        </Box>
      ) : (
        <Box>
          <IconButton onClick={handleReset} className={classes.resetButton} size="large">
            <ArrowBack />
          </IconButton>
          <StudentForm
            onSubmit={onAddStudent}
            isSubmitting={submitting}
            groups={groups}
            name={student.name}
            personalId={student.personalId}
            email={student.email}
          />
        </Box>
      )}
    </Box>
  );
};

AddStudentForm.propTypes = {
  loading: PropTypes.bool,
  submitting: PropTypes.bool,
  student: PropTypes.object,
  groups: PropTypes.array,

  onSearchStudent: PropTypes.func,
  onAddStudent: PropTypes.func,
  onResetForm: PropTypes.func,
};

AddStudentForm.defaultProps = {
  student: {},
  groups: [],
  loading: false,
  submitting: false,

  onSearchStudent() {},
  onAddStudent() {},
  onResetForm() {},
};

export default AddStudentForm;
